import React, { Component, Fragment } from 'react';

class Counter extends React.Component {

  render() {
    return (
      <Fragment>
        <div><button onClick={this.decrement.bind(this)} disabled={this.disableDecrement()}>-</button></div>
        <div><output>{this.props.number}</output></div>
        <div><button onClick={this.increment.bind(this)} disabled={this.disableIncrement()}>+</button></div>
      </Fragment>
    );
  }

  increment = (e) => {
    e.preventDefault();
    this.change(this.props.number + 1);
  }

  decrement = (e) => {
    e.preventDefault();
    this.change(this.props.number - 1);
  }

  change = (value) => {
    this.props.onChange(value);
  }

  disableIncrement() {
    if(this.props.disableIncrement){
      return true;
    }
    if(this.props.number >= 50) {
      return true;
    } else {
      return false;
    }
  }

  disableDecrement() {
    if(this.props.number <= 0) {
      return true;
    } else {
      return false;
    }
  }
}

export default Counter;
